import ReactGA from "react-ga4"
import { gaCode } from "utils/config"

export const initialiseGA = () => {
  if (localStorage.getItem("cookiesAccepted") === "true") {
    ReactGA.initialize(gaCode)
  }
}

export const removeGoogleAnalyticsCookies = () => {
  const deleteCookie = name => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`
  }

  const gaCookies = ["_ga", "_gid", "_gat"]

  gaCookies.forEach(cookie => deleteCookie(cookie))

  document.cookie.split(";").forEach(cookie => {
    const name = cookie.split("=")[0].trim()
    if (name.startsWith("_ga_")) {
      // Matches _ga_<container-id>, like _ga_5QLCY22E8
      deleteCookie(name)
    }
  })
}

export default ReactGA
